<section class="banner">
  <app-nav class="w-100"></app-nav>
  <div class="container-fluid v4-px-5 v4-adjustment">
    <div class="d-flex justify-content-between pt-5">
      <div class="d-flex mx-3">
        <i class="pi pi-file" class="andriod"></i>
        <h2 class="font-600 v4-color-white">
          {{ "Periodic Reports" | translator }}
        </h2>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center flex-wrap my-3 mx-3 w-100">
      <div class="d-flex flex-wrap">
        <span class="d-flex align-items-center">
          <span routerLink="/home" class="custom-bredcrum-btn d-flex align-items-center">
            {{ "Homepage" | translator }}
          </span>
          <span class=""><i class="pi pi-fw pi-angle-left"></i></span>
        </span>
        <span class="d-flex align-items-center">
          <span class="custom-bredcrum-btn font-600 d-flex align-items-center">
            {{ "Reports" | translator }}
          </span>
        </span>
      </div>
      <div class="d-flex flex-wrap">
        <ng-container>
          <div class="align-items-center d-flex flex-wrap">
            <a (click)="openCreateReportModal()" *ngIf="hasPermission('PERIODIC_REPORTS','c')" class="create-training-btn m-2 align-items-center d-flex">
              <i class="pi pi-plus-circle mx-2"></i>
              {{ "Create Report" | translator }}
            </a>
            <a routerLink="/home" class="create-training-btn m-2">
              <i class="pi pi-arrow-left mx-2"></i>
              {{ "Back" | translator }}
            </a>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</section>

<div class="container-fluid p-0">
  
  <div class="content-grey">
    <div class="row p-0">
      <div class="col-lg-3 col-md-6 col-12" *ngIf="mode == 'Admin' || mode == 'create'">
        <div class="d-flex flex-column">
          <div class="d-flex my-2">
            <img class="filter-brightness" src="../../../../assets/icones-2025/apartment.png" alt="loading">
            <label class="label-ui">{{"Organizational Unit" | translator}}</label>
          </div>
          <div>
            <p-treeSelect  class="pppp-tree my-2" (onNodeSelect)="currentPage = 1" (onChange)="getReports()" containerStyleClass="pppp-tree w-100" [options]="selectedTreeData" appendTo="body"  [(ngModel)]="ouFilter" placeholder="{{ 'Choose the organizational unit' | translator }}" [filter]="true" [filterInputAutoFocus]="true">
              <ng-template let-node pTemplate="default">
                <div class="d-flex">
                  <img *ngIf="checkisImg(node.data); else elseBlock" src="{{ staticURL }}{{ node.data }}" class="img-fluid p-1 tree-img-bg" style="max-height: 30px; max-width: 30px" />
                  <ng-template #elseBlock>
                    <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
                  </ng-template>
                  <b class="text-nowrap">{{ node.label }}</b>
                </div>
              </ng-template>
            </p-treeSelect>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-12" *ngIf="mode == 'Admin' || mode == 'create'">
        <div class="d-flex flex-column">
          <div class="d-flex my-2">
            <img class="filter-brightness" src="../../../../assets/icones-2025/person_2.png" alt="loading">
            <label class="label-ui">{{"Manager" | translator}}</label>
          </div>
          <div>
            <p-dropdown class="pppp-drop" [options]="this.contentUpdateUsers" (onChange)="getReports()" [(ngModel)]="managerFilter" (onChange)="null" [filter]="true" filterBy="name" [editable]="true" optionLabel="name"></p-dropdown>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex my-2">
            <img class="filter-brightness v5-img-adjustment" src="../../../../assets/icones-2025/pending_actions.png" alt="loading">
            <label class="label-ui">{{"Status"| translator}}</label>
          </div>
          <div>
            <p-dropdown filterButton (onChange)="statusFilter = $event.value" class="pppp-drop" [options]="[{e:'PENDING',a:translate('PENDING')},{e:'SIGNED',a:translate('SIGNED')},{e:'NO_DATA',a:translate('NO_DATA')}]" [(ngModel)]="statusFilter" (onChange)="getReports()" optionLabel="a" (onChange)="null" [filter]="false" [editable]="true"></p-dropdown>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex my-2">
            <img class="filter-brightness" src="../../../../assets/icones-2025/calendar_today.png" alt="loading">
            <label class="label-ui">{{"Date" | translator}}</label>
          </div>
          <div class="ppp-calander w-100">
            <p-calendar styleClass="ppp-calander" filterButton [(ngModel)]="dateRange" selectionMode="range" [showIcon]="false" [readonlyInput]="true" [showButtonBar]="true">
            </p-calendar>
          </div>
        </div>
      </div>

      <div class="col-12 d-flex justify-content-end gap-3 mt-3">
        <button class="excel-button v4-py" (click)="exportExcel()">
          <i class="fa-regular fa-file-excel mx-2"></i>
        </button>

        <button pButton type="button" class="p-button-secondary" icon="pi pi-refresh" label="{{ 'Reset' | translator }}" (click)="clearFilters()">
        </button>

        <button type="button" class="v4-btn-every py-2" label="" (click)="getReports()">
          <i class="pi pi-search"></i> {{ 'Research' | translator }}
        </button>
      </div>
      <div class="d-flex justify-content-center align-items-center my-3">
        <p-progressSpinner styleClass="w-4rem h-4rem" *ngIf="loading" strokeWidth="4"></p-progressSpinner>
      </div>
      <div class="mask">
        <div  *ngIf="!loading">
          <table>
            <thead>
              <tr>
                <th>{{"#" | translator}}</th>
                <th>{{"Content Expert" | translator}}</th>
                <th>{{"Report Form" | translator}}</th>
                <th>{{"Report To" | translator}}</th>
                <th>{{"Next Report Date" | translator}}</th>
                <th>{{"Actions" | translator}}</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let report of reports;index as i">
                <tr>
                  <td>
                    <div class="d-flex align-items-center">
                      <div class="d-flex">
                        <div class="tab-num">{{i+1}}</div>
                      </div>
                      <div class="tab-profile">
                        <img *ngIf="checkisImg(report.ou?.image); else elseBlock" src="{{ staticURL }}{{ report.ou?.image }}" class="tab-profile-img" style="max-height: 30px; max-width: 30px" />
                        <ng-template #elseBlock>
                          <i class="{{ report.ou?.image }} p-2" style="font-size: 1rem"></i>
                        </ng-template>
                      </div>
                      <div class="td-200-px">
                        {{report?.ou?.name }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="tab-grey-box">
                      <div class="d-flex">
                        <img class="tab-icone" src="../../../../assets/icones-2025/account_circle.png" alt="loading">
                      </div>
                      <div class="td-200-px">{{report?.manager?.name || 'Not signed yet' | translator }}</div>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex gap-10">
                      <div class="tab-grey-box-2">
                        <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today-(2).png" alt="loading">
                        <div>{{report?.reportForm !== 'New Report form started' ? (report.reportForm | date:'dd-MM-yyyy') : report.reportForm | translator}}</div>
                      </div>
                      <div class="d-flex align-items-center">
                        <div class="tab-arrow">
                          <img class="tab-icone" src="../../../../assets/icones-2025/arrow_cool_down.png" alt="loading">
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex gap-10">
                      <div class="tab-grey-box-2">
                        <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today-(2).png" alt="loading">
                        <div>{{report?.reportTo | date:'dd-MM-yyyy'}}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="tab-grey-box-2">
                      <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today-(2).png" alt="loading">
                      <div>{{(report?.sendingDate | date:'dd-MM-yyyy')}}</div>
                      <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading">
                      <div>{{report?.time }}</div>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex justify-content-end gap-10 border-left">
                      <div class="{{report.status === 'SIGNED' ? 'tab-grey-box-green' :  report.status === 'NO_DATA' ? 'tab-grey-box-yellow' : 'tab-grey-box-2'}}">
                        <div>{{report.status | translator}}</div>
                      </div>
                      <div class="d-flex align-items-center">
                        <div class="plus-btn mx-2" (click)="openReport(report)">
                          <img class="" src="../../../../assets/icones-2025/visibility.png" alt="loading">
                        </div>
                        <div class="plus-btn" *ngIf="hasPermission('PERIODIC_REPORTS','d')" (click)="reportId = report._id; confirmationDialog = true">
                          <i class="pi pi-times" style="font-size: 0.9rem"></i>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="mx-2">
    <p-paginator [rows]="10" [totalRecords]="totalCount" [rowsPerPageOptions]="[10,20,30]" [showCurrentPageReport]="true" (onPageChange)="onPageChange($event)">
    </p-paginator>
  </div>

  <app-footer></app-footer>

  <p-dialog [blockScroll]="true" [draggable]="false" (onHide)="closeModal(false)" header="{{ 'Create Report' | translator }}" [(visible)]="createReport" [style]="{ width: '95vw', maxWidth: '1000px' }">
    <app-create-periodic-reports *ngIf="createReport" [mode]="mode" [report]="report" (closeModal)="closeModal($event)">
    </app-create-periodic-reports>
  </p-dialog>
</div>


<p-dialog [blockScroll]="true"  [draggable]="false" header="{{ 'Confirm' | translator }}" [(visible)]="confirmationDialog" [style]="{ width: '30vw', maxWidth: '1000px' }">
<!-- Start Generation Here -->
<div class="confirmation-ui">
  <h3>{{ 'Confirmation' | translator }}</h3>
  <p>{{ 'Are you sure you want to delete this report' | translator }}</p>
  <div class="d-flex">
    <div class="yes-btn" (click)="deleteReportAPI(reportId); confirmationDialog = false">
      <label class="cursor">{{ 'Yes' | translator }}</label>
    </div>
    <div class="no-btn" (click)="confirmationDialog = false">
      <label class="cursor">{{ 'No' | translator }}</label>
    </div>
  </div>
</div>
<!-- End Generation Here -->
</p-dialog>
